import Image from 'app/Components/Shared/Image/image';
import React, { useState, useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { openModal, setFlightManager, setMultipleBans, setSelectedMembers, removeOtpData, saveToHistory } from '../CellcomAbroadLobbyBlock/cellcomAbroadBlockSlice';
import { popupReasonEnum, saleOTPSteps } from '../CellcomAbroadLobbyBlock/cellcomAbroadVariables';
import PopUpWithAnimation from '../../Shared/PopUpWithAnimation/PopUpWithAnimation';
import OtpExtendedPopup from '../SelfcareExtendedOtpButtonBlock/PopUp/OtpExtendedPopup';
import FlightManagerSelector from './FlightManagerSelector';
import './FamilyBundleSection.scss';
import userIcon from './images/userIcon.svg';
import editIcon from './images/editIcon.svg';

import { resetLoginData } from '../../../utilities/authentication/authenticationSlice';
import { getSelfCareData, Onboarding } from '../../Page/SelfCarePage/SelfCareAsyncThunk';

function FamilyBundleSection(props) {
  const { flightManager, selectedMembers, availableMembers, multipleBans, openModal, setFlightManager, setMultipleBans, setSelectedMembers, authentication, selfcarePage, setShowMessage, setErrorMessageText, setSaleOtpStep } = props;
  const dispatch = useDispatch();
  const [showOtpExtendedPopup, setShowOtpExtendedPopup] = useState(false);
  // Track that the user already completed OTP-extended this session so we don't gate them again
  const [otpExtendedDone, setOtpExtendedDone] = useState(false);

  // Check if user is in OTP mode (not full or OTP extended)
  const isOtpMode = (authentication?.loginData?.isOtpAuthenticated &&
    !authentication?.loginData?.isFullAuthenticated &&
    !authentication?.loginData?.isOtpExtendedAuthenticated);

  // Get cellular subscribers from selfcare onboarding data
  const cellularSubscribers = selfcarePage?.subscribersByProduct?.Cellular || [];
  const currentSubscriberNumber = authentication?.loginData?.userDetails?.contactNumber;

  // Filter for subscribers under the current subscriber
  const subscribersUnderCurrent = cellularSubscribers.filter(subscriber =>
    subscriber.productSubscriberNo !== currentSubscriberNumber &&
    subscriber.parentSubscriberNo === currentSubscriberNumber
  );

  console.log('All cellular subscribers:', cellularSubscribers);
  console.log('Current subscriber:', currentSubscriberNumber);
  console.log('Subscribers under current:', subscribersUnderCurrent);

  // Detect if there are multiple BANs
  useEffect(() => {
    if (cellularSubscribers.length > 0) {
      const uniqueBans = [...new Set(cellularSubscribers.map(subscriber => subscriber.ban).filter(Boolean))];
      console.log('Unique BANs found:', uniqueBans);
      const hasMultipleBans = uniqueBans.length > 1;
      console.log('Has multiple BANs:', hasMultipleBans);
      if (hasMultipleBans !== multipleBans) {
        console.log('Updating multipleBans to:', hasMultipleBans);
        setMultipleBans(hasMultipleBans);
      }
    }
  }, [cellularSubscribers, multipleBans, setMultipleBans]);

  // desiredFm holds the locally-computed flight manager value.
  // Separating computation (Effect 1) from application (Effect 2) avoids a React 18
  // automatic-batching race where the parent's resetFamilyBundleData() fires in the same
  // effect flush and nets out to null before React even sees the setFlightManager dispatch.
  const [desiredFm, setDesiredFm] = useState(null);

  // Effect 1 — compute: derives the desired FM from auth/subscriber data.
  // Does NOT include flightManager in deps — we only recompute when the source data changes.
  useEffect(() => {
    const isPrimaryContact = authentication?.loginData?.userDetails?.IsPrimaryContact || authentication?.loginData?.userDetails?.IsContactPerson;
    if (!currentSubscriberNumber || (!isPrimaryContact && !isOtpMode)) return;

    let defaultFlightManager;
    if (cellularSubscribers.length === 1) {
      defaultFlightManager = cellularSubscribers[0];
    } else {
      defaultFlightManager = cellularSubscribers.find(
        subscriber => subscriber.productSubscriberNo === currentSubscriberNumber
      );
    }


    if (defaultFlightManager) {
      setDesiredFm({
        ...defaultFlightManager,
        phone: defaultFlightManager.productSubscriberNo,
        name: `${defaultFlightManager.productFirstName} ${defaultFlightManager.productLastName}`.trim(),
        id: defaultFlightManager.productSubscriberNo,
      });
    } else if (isOtpMode) {
      // Cellular data may not be loaded yet — set from contact number directly
      setDesiredFm({
        phone: currentSubscriberNumber,
        name: currentSubscriberNumber,
        id: currentSubscriberNumber,
      });
    }
  }, [currentSubscriberNumber, authentication?.loginData?.userDetails?.IsPrimaryContact, authentication?.loginData?.userDetails?.IsContactPerson, cellularSubscribers, isOtpMode]);

  // Effect 2 — apply: pushes desiredFm into Redux when FM is null due to an external reset
  // (e.g. resetFamilyBundleData on mount). Skips when FM was intentionally cleared (flightManagerCleared
  // flag in Redux), so clearing from a popup stays respected even across component remounts.
  // Also re-enriches FM when it was set before subscriber data loaded
  useEffect(() => {
    if (!desiredFm || props.flightManagerCleared) return;

    const getBan = (fm) => fm?.ban || fm?.productBan;
    const desiredHasBan = getBan(desiredFm);
    const currentHasBan = getBan(flightManager);

    if (!flightManager) {
      setFlightManager(desiredFm);
      return;
    }

    if (!currentHasBan && desiredHasBan && flightManager.phone === desiredFm.phone) {
      setFlightManager(desiredFm);
    }
  }, [flightManager, desiredFm, props.flightManagerCleared]);

  const handleOpenMemberSelection = async () => {
    console.log('[FamilyBundleSection] handleOpenMemberSelection called');
    console.log('[FamilyBundleSection] isOtpMode:', isOtpMode);
    console.log('[FamilyBundleSection] otpExtendedDone:', otpExtendedDone);
    console.log('[FamilyBundleSection] isOtpExtendedAuthenticated:', authentication?.loginData?.isOtpExtendedAuthenticated);

    // In OTP mode or OTP-extended mode the logged-in user IS the flight manager — no need to guard.
    // In non-OTP/non-OTP-extended mode, require an explicit flight manager selection.
    const isOtpExtendedMode = authentication?.loginData?.isOtpExtendedAuthenticated;
    if (!flightManager) {
      console.log('[FamilyBundleSection] No flight manager - showing error');
      if (setErrorMessageText) setErrorMessageText('יש לבחור מנהל טיסה לפני הוספת מנויים');
      if (setShowMessage) setShowMessage(true);
      return;
    }

    // Clear the error message when opening member selection
    if (setShowMessage) {
      setShowMessage(false);
    }

    // If in OTP mode AND hasn't yet done OTP-extended this session, show the extend popup
    if (isOtpMode && !otpExtendedDone) {
      console.log('[FamilyBundleSection] Showing OTP extended popup');
      setShowOtpExtendedPopup(true);
      return;
    }

    // If OTP-extended and subscriber list is still stale (only 1 entry from original OTP session),
    // refresh Onboarding+SelfCareData before opening so the popup sees the full family list.
    if (isOtpExtendedMode && cellularSubscribers.length <= 1) {
      console.log('[FamilyBundleSection] OTP extended but stale data - refreshing...');
      await dispatch(Onboarding());
    }

    // Ensure multipleBans is current before opening
    if (cellularSubscribers.length > 0) {
      const uniqueBans = [...new Set(cellularSubscribers.map(subscriber => subscriber.ban).filter(Boolean))];
      const hasMultipleBansNow = uniqueBans.length > 1;
      if (hasMultipleBansNow !== multipleBans) {
        setMultipleBans(hasMultipleBansNow);
      }

      // Re-enrich flight manager if it was set before subscriber data loaded (missing ban)
      if (flightManager?.phone && !(flightManager.ban || flightManager.productBan)) {
        const fullFm = cellularSubscribers.find(
          s => s.productSubscriberNo === flightManager.phone
        );
        if (fullFm) {
          setFlightManager({
            ...fullFm,
            phone: fullFm.productSubscriberNo,
            name: `${fullFm.productFirstName} ${fullFm.productLastName}`.trim(),
            id: fullFm.productSubscriberNo,
          });
        }
      }
    }

    console.log('[FamilyBundleSection] Opening SELECT_FAMILY_MEMBERS modal');
    openModal(popupReasonEnum.SELECT_FAMILY_MEMBERS);
  };

  // Run Onboarding then getSelfCareData inline (not via useEffect) so that the full subscriber
  // list is in Redux BEFORE the popup opens — and before SelfCare.js's refetchData-triggered
  // getSelfCareData can race ahead and cement the stale single-subscriber state.
  const handleOtpExtendedFinished = async () => {
    console.log('[FamilyBundleSection] handleOtpExtendedFinished START');
    console.log('[FamilyBundleSection] openModal function:', openModal);
    console.log('[FamilyBundleSection] cellularSubscribers BEFORE:', cellularSubscribers.length);

    setShowOtpExtendedPopup(false);
    setOtpExtendedDone(true);
    setSaleOtpStep(saleOTPSteps.LOADER);
    console.log('[FamilyBundleSection] Dispatching Onboarding...');
    const onboardingResult = await dispatch(Onboarding());
    console.log('[FamilyBundleSection] Onboarding result:', onboardingResult);

    console.log('[FamilyBundleSection] Dispatching getSelfCareData...');
    const selfCareResult = await dispatch(getSelfCareData());
    console.log('[FamilyBundleSection] getSelfCareData result:', selfCareResult);

    // Wait a tick for the OTP popup to fully close before opening the select members modal
    setSaleOtpStep(saleOTPSteps.AFTER_INPUT);


    console.log('[FamilyBundleSection] Calling openModal with SELECT_FAMILY_MEMBERS');
    console.log('[FamilyBundleSection] popupReasonEnum.SELECT_FAMILY_MEMBERS:', popupReasonEnum.SELECT_FAMILY_MEMBERS);
    openModal(popupReasonEnum.SELECT_FAMILY_MEMBERS);
    console.log('[FamilyBundleSection] handleOtpExtendedFinished END');
  };

  console.log(availableMembers);
  console.log(props);
  console.log(multipleBans);

  // Use cellular subscribers as available members
  const availableMembersFromSelfcare = cellularSubscribers.map(subscriber => ({
    id: subscriber.productSubscriberNo,
    phone: subscriber.productSubscriberNo,
    name: `${subscriber.productFirstName} ${subscriber.productLastName}`.trim(),
    ...subscriber
  }));

  const handleFlightManagerChange = (member) => {
    setDesiredFm(null);   // user is making an explicit choice — stop auto-applying
    setFlightManager(member);
    // Deselect all members when flight manager changes
    if (member) {
      setSelectedMembers([{ phone: member.phone, name: member.name }]);
    }
    // Only clear error message when a valid flight manager is selected
    if (member && setShowMessage) {
      setShowMessage(false);
    }
  };

  const handleLogout = () => {
    props.resetLoginData();
    props.removeOtpData();
    props.saveToHistory();
  };


  // Get selected members details (excluding flight manager)
  const selectedMembersDetails = selectedMembers
    .filter(member => {
      const phone = typeof member === 'string' ? member : member.phone;
      return phone !== flightManager?.phone;
    })
    .map(member => {
      // If member is already an object with phone and name, return it
      if (typeof member === 'object' && member.phone) {
        return member;
      }
      // If member is just a phone string, find full details
      const phone = typeof member === 'string' ? member : member.phone;
      const fullMember = availableMembersFromSelfcare.find(m => m.phone === phone || m.productSubscriberNo === phone);
      return fullMember || { phone };
    });

  // selectedMembersDetails already excludes the flight manager — any entry is an additional family member
  const hasSelectedMembers = selectedMembersDetails.length > 0;

  // true when there is at least one subscriber other than the flight manager to add
  const hasSelectableMembers = availableMembersFromSelfcare.some(
    m => m.phone !== flightManager?.phone
  );

  // Check if user is primary contact
  const isPrimaryContact = authentication?.loginData?.userDetails?.IsPrimaryContact || authentication?.loginData?.userDetails?.IsContactPerson;

  return (
    <div className="family-bundle-section">
      <div className="family-bundle-title">מי יטוס בחבילה המשפחתית?</div>

      <FlightManagerSelector
        flightManager={flightManager}
        availableMembers={availableMembersFromSelfcare}
        isOtpMode={isOtpMode}
        contactNumber={authentication?.loginData?.userDetails?.contactNumber}
        onFlightManagerChange={handleFlightManagerChange}
        showLogoutButton={true}
        onLogout={handleLogout}
      >
        <div className={`add-family-member-container ${isOtpMode ? 'otp-mode' : ''}`}>
          {hasSelectedMembers ? (
            <div className="selected-members-display">
              <div className='selected-members-title'>המנויים בחבילה (מלבד מנהל הטיסה)</div>
              <div className="selected-members-list">
                {selectedMembersDetails.map((member, index) => (
                  <div key={member.phone} className="selected-member-item">
                    <Image src={userIcon} alt="member" className="member-icon" />
                    <span className="member-phone">{member.phone}</span>
                    {member.name && <span className="member-name">{member.name}</span>}
                  </div>
                ))}
              </div>
              <div className="update-members-button" onClick={handleOpenMemberSelection}>
                <Image src={editIcon} alt="edit" className="edit-icon" />
                עדכון מנויים
              </div>
            </div>
          ) : (
            <>
              <div
                className={`add-family-member-button ${isPrimaryContact && !hasSelectedMembers ? 'primary-contact-no-members' : ''}`}
                onClick={handleOpenMemberSelection}
              >
                לצירוף מנויים לחבילה
              </div>
            </>
          )}
        </div>
      </FlightManagerSelector>

      {isOtpMode && (
        <div className={`add-family-member-container otp-mode`}>
          <div className="add-family-member-button" onClick={handleOpenMemberSelection}>
            לצירוף מנויים לחבילה
          </div>
        </div>
      )}

      {showOtpExtendedPopup && (
        <PopUpWithAnimation
          className='selfcareExtendedOtpPopUp'
          isShow={showOtpExtendedPopup}
          onClose={() => setShowOtpExtendedPopup(false)}
        >
          <OtpExtendedPopup
            setShowPopUp={setShowOtpExtendedPopup}
            showPopup={showOtpExtendedPopup}
            setOtpExtendedFinished={handleOtpExtendedFinished}
            skipRefetchData={true}
            title={'כדי להוסיף בני משפחה צריך אישור מורחב'}
            subTitle={'נשלח לכם קוד אימות נוסף שאיתו תוכלו להמשיך'}
          />
        </PopUpWithAnimation>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  flightManager: state.cellcomAbroad.familyBundleData.flightManager,
  flightManagerCleared: state.cellcomAbroad.familyBundleData.flightManagerCleared,
  selectedMembers: state.cellcomAbroad.familyBundleData.selectedMembers,
  availableMembers: state.cellcomAbroad.familyBundleData.availableMembers,
  multipleBans: state.cellcomAbroad.familyBundleData.multipleBans,
  authentication: state.authentication,
  cellcomAbroad: state.cellcomAbroad,
  selfcarePage: state.selfcarePage
});

const mapDispatchToProps = {
  openModal,
  setFlightManager,
  setMultipleBans,
  setSelectedMembers,
  resetLoginData,
  removeOtpData,
  saveToHistory,
};

export default connect(mapStateToProps, mapDispatchToProps)(FamilyBundleSection);
